"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var dayjs_1 = tslib_1.__importDefault(require("dayjs"));
var customParseFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/customParseFormat"));
var updateLocale_1 = tslib_1.__importDefault(require("dayjs/plugin/updateLocale"));
var localeData_1 = tslib_1.__importDefault(require("dayjs/plugin/localeData"));
var quarterOfYear_1 = tslib_1.__importDefault(require("dayjs/plugin/quarterOfYear"));
var advancedFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/advancedFormat"));
var weekOfYear_1 = tslib_1.__importDefault(require("dayjs/plugin/weekOfYear"));
var weekYear_1 = tslib_1.__importDefault(require("dayjs/plugin/weekYear"));
require("dayjs/locale/zh-cn");
dayjs_1.default.extend(advancedFormat_1.default);
dayjs_1.default.extend(quarterOfYear_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
dayjs_1.default.extend(updateLocale_1.default);
dayjs_1.default.extend(localeData_1.default);
dayjs_1.default.extend(weekOfYear_1.default);
dayjs_1.default.extend(weekYear_1.default);
dayjs_1.default.locale('zh-cn');
var datejs = dayjs_1.default;
datejs.isSelf = dayjs_1.default.isDayjs;
dayjs_1.default.localeData();
exports.default = datejs;
